import { render, staticRenderFns } from "./LoginTermModal.vue?vue&type=template&id=283eaa00&"
import script from "./LoginTermModal.vue?vue&type=script&lang=js&"
export * from "./LoginTermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports